export default "__VITE_ASSET__CuSCeoTX__"